var _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_375_4604",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 43,
    height: 43
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9766 44.397C36.0226 44.397 44.9766 35.443 44.9766 24.397C44.9766 13.351 36.0226 4.39697 24.9766 4.39697C13.9306 4.39697 4.97656 13.351 4.97656 24.397C4.97656 35.443 13.9306 44.397 24.9766 44.397Z",
    fill: "white",
    fillOpacity: 0.5,
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9766 16.397V32.397V16.397ZM16.9766 24.397H32.9766H16.9766Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9766 16.397V32.397M16.9766 24.397H32.9766",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_375_4604)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.976562 0.396973H48.9766V48.397H0.976562V0.396973Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusWhiteIcon);
export default __webpack_public_path__ + "static/media/plusWhiteIcon.00a8837dea70471d4cb82f42431b4378.svg";
export { ForwardRef as ReactComponent };